import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";
import UpdateApi from "./UpdateApi";

const apiUrl = config.apiUrl;

const ViewApi = () => {
  const [automations, setAutomations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingAutomation, setEditingAutomation] = useState(null);
  const [formData, setFormData] = useState({
    slug: "",
    api: "",
    list: "",
  });

  // Fetch automations from API
  useEffect(() => {
    const fetchAutomations = async () => {
      try {
        const response = await axios.get(`${apiUrl}/automations`);
        setAutomations(response.data.automations || []);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching automations:", err);
        setError("Failed to load automations.");
        setLoading(false);
      }
    };

    fetchAutomations();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this automation?")) {
      try {
        await axios.delete(`${apiUrl}/automationdelete/${id}`);
        setAutomations((prev) => prev.filter((automation) => automation.id !== id));
      } catch (err) {
        console.error("Error deleting automation:", err);
        setError("Failed to delete automation.");
      }
    }
  };

  // Handle Edit Button Click
  const handleEditClick = (automation) => {
    setEditingAutomation(automation.id);
    setFormData({
      slug: automation.slug,
      api: automation.api,
      list: automation.list,
    });
  };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingAutomation) {
      setError("No automation selected for editing.");
      return;
    }

    try {
      await axios.put(`${apiUrl}/automationsupdate/${editingAutomation}`, formData);
      alert("Automation updated successfully");
      setAutomations((prev) =>
        prev.map((automation) =>
          automation.id === editingAutomation
            ? { ...automation, ...formData }
            : automation
        )
      );
      setEditingAutomation(null); // Clear editing state
    } catch (err) {
      console.error("Error updating automation:", err);
      setError("Failed to update automation.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Automation List</h2>
      {error && <p className="text-red-500">{error}</p>}
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Slug</th>
            <th className="border border-gray-300 px-4 py-2">API</th>
            <th className="border border-gray-300 px-4 py-2">List</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {automations.map((automation) => (
            <tr key={automation.id}>
              <td className="border border-gray-300 px-4 py-2">{automation.slug}</td>
              <td className="border border-gray-300 px-4 py-2">{automation.api}</td>
              <td className="border border-gray-300 px-4 py-2">{automation.list}</td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(automation)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(automation.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingAutomation && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateApi 
                formData = {formData}
                handleChange = {handleChange}
                handleSubmit = {handleSubmit}
                loading = {loading}
                error = {error}
                onCancel={() => setEditingAutomation(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewApi;
